export default __webpack_public_path__ + "static/media/rating.3cbae434.png";